import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgActive = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m8.6 20.1-7.8-8 1.4-1.4 6.4 6.5L21.8 3.9l1.4 1.4L8.6 20.1z" })
});
export default SvgActive;
